import { createAction } from '@reduxjs/toolkit';

export const submitStep = createAction('contract/submitStep');
export const backToStep = createAction('contract/backToStep');
export const updateStepData = createAction('contract/updateStepData');
